import { tileKey as l, fetchableTileKey as s } from "../shared/tiles.js";
class h {
  mapId;
  tile;
  imageRequest;
  tileUrl;
  tileKey;
  fetchableTileKey;
  /**
   * Creates an instance of FetchableTile.
   *
   * @constructor
   * @param {Tile} tile - the tile
   * @param {WarpedMapWithImageInfo} warpedMap - A WarpedMap with fetched image information
   */
  constructor(e, t) {
    this.mapId = t.mapId, this.tile = e;
    const i = t.parsedImage.getIiifTile(
      e.tileZoomLevel,
      e.column,
      e.row
    );
    this.imageRequest = i, this.tileUrl = t.parsedImage.getImageUrl(i), this.tileKey = l(e), this.fetchableTileKey = s(this);
  }
}
export {
  h as default
};
//# sourceMappingURL=FetchableTile.js.map
